import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { PORT_STATUS, featuresForPage, statusForPage } from '../data/portStatus';

// The status pill. Sidebar rows use the short word; the page strip and the status page
// use the whole label.
export function PortPill({ status, short = false }) {
  const s = PORT_STATUS[status];
  if (!s) return null;
  return <span className={`port-pill port-${status}`} title={s.label}>{short ? s.short : s.label}</span>;
}

export function PortNavBadge({ page }) {
  const status = statusForPage(page);
  return status ? <PortPill status={status} short /> : null;
}

const NOTHING_LEFT = /^Nothing\./;

// A Not ported row opens "All of it: ...", which reads wrongly after the strip's own lead-in.
const leftText = (f) => (f.remaining || '').replace(/^All of it: /, '');

// The strip above a page. Silent on pages that only exist in CPX. Staff asked what still
// has to be done in the admin portal, so that is what it leads with, one line per feature
// that has anything left; a feature waiting only on its parity test stays out of the way.
export function PortStatusBar({ page, navigateTo }) {
  const [open, setOpen] = useState(false);
  const features = featuresForPage(page);
  const status = statusForPage(page);
  if (!status) return null;
  const left = features.filter((f) => f.status !== 'full' && !NOTHING_LEFT.test(f.remaining || ''));
  const single = features.length === 1;
  let summary;
  if (status === 'full') summary = 'Everything from the admin portal is here.';
  else if (left.length === 0) summary = 'Everything from the admin portal is here. Waiting on a parity test.';
  else if (single) summary = `Still in the admin portal: ${leftText(left[0])}`;
  else summary = `${left.length} of ${features.length} admin portal features still need the admin portal.`;
  const canOpen = !single && left.length > 0;
  return (
    <div className="port-bar">
      <div className="port-bar-row">
        <PortPill status={status} />
        <span className="port-bar-text">{summary}</span>
        {canOpen && (
          <button type="button" className="port-bar-toggle" onClick={() => setOpen((o) => !o)}>
            {open ? <ChevronDown size={13} /> : <ChevronRight size={13} />} {open ? 'Hide' : 'Show'}
          </button>
        )}
        <button type="button" className="port-bar-toggle" onClick={() => navigateTo('port-status')}>All features</button>
      </div>
      {open && (
        <ul className="port-bar-list">
          {left.map((f) => <li key={f.id}><strong>{f.label}:</strong> {leftText(f)}</li>)}
        </ul>
      )}
    </div>
  );
}
